import moment from 'moment';
/**
 * 将时间戳专为标准格式
 * @param value 时间戳
 * @param format
 * @returns
 */
export function dateFormat(
  value: number,
  format = 'YYYY-MM-DD HH:mm:ss'
): string {
  return moment(value).format(format);
}
